import {AxiosError, AxiosInstance} from 'axios';

interface SessionStore {
    dispatch(action: string): Promise<unknown>;
}

interface SessionRouter {
    currentRoute: {path: string; fullPath: string};
    replace(location: {path: string; query: {redirect: string}}): Promise<unknown> | void;
}

export function installSessionInterceptor(client: AxiosInstance, store: SessionStore, router: SessionRouter): number {
    let pendingLogout: Promise<void> | null = null;

    return client.interceptors.response.use(response => response, (error: AxiosError) => {
        if (error.response && error.response.status === 401 && !pendingLogout) {
            const redirect = router.currentRoute.fullPath;
            pendingLogout = (async () => {
                await store.dispatch('logout');
                if (router.currentRoute.path !== '/login') {
                    await router.replace({path: '/login', query: {redirect}});
                }
            })()
                // A failed navigation must not replace the original HTTP error.
                .catch(() => undefined)
                .finally(() => { pendingLogout = null; });
        }

        // Do not wait for navigation: its guard may itself request translations.
        return Promise.reject(error);
    });
}
